import { render } from "./index.vue?vue&type=template&id=deeb250e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=deeb250e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-deeb250e"

export default script